import { AppSettingsService } from '@fc-core/services/app-settings.service';
import { AnalyticsService } from '@fc-core/services/analytics.service';
import { AppSettings } from '@fc-core/models/app.settings';
import { Injectable } from '@angular/core';
import { AuthService } from '@fc-core';
import { Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AmplitudeService } from './amplitude.service';

@Injectable()
export class AppInitService {
  constructor(
    private auth: AuthService,
    private appSettingsService: AppSettingsService,
    private analyticsService: AnalyticsService,
    private amplitudeService: AmplitudeService,
  ) {}

  init(): Observable<AppSettings | null> {
    this.analyticsService.initHubSpotChat();

    if (environment.environment === 'production') {
      this.analyticsService.initGoogleAnalytics();
      this.analyticsService.setUpConfig();
      this.analyticsService.setAppVersion();
    }

    if (!this.auth.loggedIn || !this.auth.tokenData?.timezone) {
      return of(null);
    }

    this.amplitudeService.initAmplitude();

    const cachedAppSettings =
      this.appSettingsService.getCachedEmployeeAppSettings();
    if (cachedAppSettings) {
      this.appSettingsService.refreshEmployeeAppSettings();
      return of(cachedAppSettings);
    }

    return this.appSettingsService.getEmployeeAppSettings();
  }
}
